const laneToggleButtonsOpenClass = "process_map__lane__line--active";

const allLanesToggleButtonExpandTextClass   = ".process_map__options__panel__expand_button__text__expand";
const allLanesToggleButtonCollapseTextClass = ".process_map__options__panel__expand_button__text__collapse";
const allLanesToggleButtonTextActiveClass   = "process_map__options__panel__expand_button__text--active";
const allLanesToggleButtonExpandText        = document.querySelector(allLanesToggleButtonExpandTextClass);
const allLanesToggleButtonCollapseText      = document.querySelector(allLanesToggleButtonCollapseTextClass);

if (!allLanesToggleButtonExpandText) {
    console.error(`Could not find any button text with the selector: ${allLanesToggleButtonExpandTextClass}`);
};
if (!allLanesToggleButtonCollapseText) {
    console.error(`Could not find any button text with the selector: ${allLanesToggleButtonCollapseTextClass}`);
};

function toggleButtonEventHandler (event, buttons) {
    const isOpen = event.target.dataset.toggledOpen === "true";
    for (let i = 0; i < buttons.length; i++) {
        // add and remove active class to button text
        // add lane toggle button active class to element
        if (isOpen) {
            allLanesToggleButtonCollapseText.classList.remove(allLanesToggleButtonTextActiveClass);
            allLanesToggleButtonExpandText.classList.add(allLanesToggleButtonTextActiveClass);
            buttons[i].classList.remove(laneToggleButtonsOpenClass);
        } else {
            allLanesToggleButtonExpandText.classList.remove(allLanesToggleButtonTextActiveClass);
            allLanesToggleButtonCollapseText.classList.add(allLanesToggleButtonTextActiveClass);
            buttons[i].classList.add(laneToggleButtonsOpenClass);
        }
    }
    event.target.dataset.toggledOpen = !isOpen;
}

module.exports = {
    init: () => {
        // get button element that toggles all lanes
        const allLanesToggleButtonClass = ".process_map__options__panel__expand_button";
        const allLanesToggleButton      = document.querySelector(allLanesToggleButtonClass);

        if (!allLanesToggleButton) {
            console.error(`Could not find a button with the selector: ${allLanesToggleButtonClass}`);
            return;
        };

        // get each lane toggle button element
        const laneToggleButtonsClass     = ".process_map__lane__line";
        const laneToggleButtons          = document.querySelectorAll(laneToggleButtonsClass);
        if (!laneToggleButtons) {
            console.error(`Could not find any buttons with the selector: ${laneToggleButtonsClass}`);
            return;
        };

        allLanesToggleButton.dataset.toggledOpen = false;
        allLanesToggleButton.onclick = (event) => {
            return toggleButtonEventHandler(event, laneToggleButtons);
        };
    }
};
